/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement } from "react";
import { useStoreContext } from "../../contexts/StoreProvider";
import SessionTimer from "./SessionTimer";
import VersionChecker from "./VersionChecker";
import AuthChecker from "./AuthChecker";

type PropsType = {
  children: ReactElement | ReactElement[];
};

const Session = ({ children }: PropsType) => {
  const {
    state: { authenticated },
  } = useStoreContext();

  return authenticated ? (
      <SessionTimer>
        <VersionChecker>{children}</VersionChecker>
        <AuthChecker/>
      </SessionTimer>
  ) : (
    <VersionChecker>{children}</VersionChecker>
  );
};

export default Session;
